module.exports = __webpack_public_path__ + "img/pilcrow-02.2db32b24.svg";